import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { FaStar } from "react-icons/fa";
import { Check } from "lucide-react";
import GeneralEnquiry from "../GeneralEnquiry/GeneralEnquiry";
import isEmpty from "../utils/isEmpty";
import { useNavigate } from "react-router-dom";

const ENQUIRY_OPTIONS = [
  "Selling a property",
  "Property Management",
  "An advertised property",
  "General enquiry",
];

const AgentContactCard = ({ AgentData, averageRatings }) => {
  const [next, setNext] = useState(true);
  const [whichActive, setWhichActive] = useState("Selling a property");
  const navigate = useNavigate();

  const rating =
    averageRatings != null && !isNaN(Number(averageRatings))
      ? Number(averageRatings).toFixed(1)
      : "5.0";
  const reviewCount = AgentData?.reviews?.length ?? 0;
  const agentName =
    [AgentData?.first_name, AgentData?.last_name].filter(Boolean).join(" ") ||
    "Agent";
  const agencyName =
    AgentData?.agency_id?.principal_name ??
    AgentData?.agency_id?.agency_name ??
    "Agency";
  const agencyLogo = AgentData?.agency_id?.agencySmallLogo;
  const headerBg = AgentData?.agency_id?.primary_color
    ? AgentData?.agency_id?.primary_color
    : "#171717";


  if (isEmpty(AgentData)) return null;

  if (!next) {
    return (
      <GeneralEnquiry
        setNext={setNext}
        whichActive={whichActive}
        data={AgentData}
      />
    );
  }

  return (
    <div className="bg-white rounded-xl overflow-hidden">
      {
        <div
          className="px-6 py-3 flex justify-center items-center cursor-pointer md:rounded-t-xl"
          style={{ backgroundColor: headerBg }}
        >
          <LazyLoadImage
            src={agencyLogo}
            alt=""
            effect="blur"
            className="h-8 max-w-[180px] object-contain object-center"
            onClick={() => navigate(`/agency-profile/${AgentData?.agency_id?._id}`)}
          />
          {!agencyLogo && (
            <span className="text-white font-semibold text-lg tracking-wide" onClick={() => navigate(`/agency-profile/${AgentData?.agency_id?._id}`)}>
              {agencyName.toUpperCase()}
            </span>
          )}
        </div>
      }

      <div className="p-4 md:p-6">
        <div className="flex gap-4 items-center">
          <LazyLoadImage
            src={AgentData?.profileImg}
            alt=""
            effect="blur"
            className="w-14 h-14 md:w-16 md:h-16 rounded-full object-cover flex-shrink-0 bg-[#F5F5F5]"
          />
          <div>
            <h3 className="text-[#171717] font-bold text-lg md:text-xl">
              {agentName}
            </h3>
            <div className="flex items-center gap-1.5 mt-0.5 text-[#737373] text-sm">
              <FaStar className="text-[#FFB200] w-4 h-4 flex-shrink-0" />
              <span>{rating}</span>
              <span>({reviewCount} reviews)</span>
            </div>
          </div>
        </div>

        <h4 className="text-[#171717] font-bold text-base md:text-lg mt-6 mb-4">
          What's your enquiry about?
        </h4>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {ENQUIRY_OPTIONS.map((option) => {
            const isSelected = whichActive === option;
            return (
              <button
                key={option}
                type="button"
                onClick={() => setWhichActive(option)}
                className={`flex items-center justify-between rounded-full border-[1.5px] p-[13px_12px_13px_24px] text-left text-sm transition-colors ${isSelected
                  ? "border-[#097FE6] bg-[#E3F2FD] text-[#171717]"
                  : "border-[#E5E5E5] bg-white text-[#171717] hover:border-[#D0D0D0]"
                  }`}
              >
                <span>{option}</span>
                {isSelected && (
                  <span className="w-6 h-6 rounded-full bg-[#097FE6] flex items-center justify-center flex-shrink-0">
                    <Check className="w-4 h-4 text-white" strokeWidth={3} />
                  </span>
                )}
              </button>
            );
          })}
        </div>

        <button
          type="button"
          onClick={() => setNext(false)}
          className="w-full mt-6 rounded-xl bg-[#097FE6] text-white text-base font-bold py-3.5 px-4 hover:bg-[#0869c9] transition-colors"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default AgentContactCard;
